$(document).ready(function(){
  // modal code //
  $('.trigger-modal').click(function(){
    var modal = new theme.Modals($(this).attr('data-target'), $(this).attr('data-target')+'-modal');
    if($(this).attr('data-target') == 'VideoModal'){
      var video_link = $(this).attr('data-video-link')
      if(video_link != undefined && video_link != ''){
        if(video_link.indexOf('//player.vimeo.com/video') > -1){
          console.log(video_link)
          $('#VideoHolder').html('<iframe src="'+video_link+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>')
        }
        else{
          $('#VideoHolder').html(videoEmbed.convertMedia($(this).attr('data-video-link')))
        }
      }
    }
    modal.open();
  })
}) 

function openklarnaPopup(){
  $('#klarna-popup-cart').css({"z-index":"999999","display":"block","opacity":"1"});
  $('.news-window-cover').css({"z-index":"999997","display":"block","opacity":"1"});
}

function closeklarnaPopup(){
   $('#klarna-popup-cart').css({"z-index":"0","display":"none","opacity":"0"});
  $('.news-window-cover').css({"z-index":"0","display":"none","opacity":"0"});
}
$(document).ready(function(){
  var totalmoney=parseInt($('#CartDrawerForm .cart-sub-price').text().replace(/[^0-9]/ig,""));
  var totalfour=totalmoney/400;
  totalfour = totalfour.toFixed(2);
  $("#CartDrawerForm .drawer-cart-installments .right-ajax-price").html("$"+totalfour);
})
$(document).ready(function(){
  var totalmoney=parseInt($('#CartPageForm .cart-sub-price').text().replace(/[^0-9]/ig,""));
  var totalfour=totalmoney/400;
  totalfour = totalfour.toFixed(2);
  $("#CartPageForm .drawer-cart-installments .right-ajax-price").html("$"+totalfour);
})
$(function () {
          if($(".home-recommend_head .home-recommend_btn.col").length == 0){
            $(".home-recommend_head .home-recommend_btn:eq(0)").addClass("active");
            $('.home-recommend_proBox .recommend_pro-list:eq(0)').css('display','block');
          }
  
        $(".home-recommend_head .home-recommend_btn").click(function(){
            $(this).addClass("active").siblings().removeClass("active");
            $(".home-recommend_proBox .recommend_pro-list").hide().eq($(this).index()).show();
         })
})
window.timeZoneParams = -5;
window.getLocalTime = function (i) {
    if (typeof i !== 'number') return;
    var d = new Date();
    var len = d.getTime();
    var offset = d.getTimezoneOffset() * 60000;
    var utcTime = len + offset;
    return new Date(utcTime + 3600000 * i);
}

window.getNextDate = function(date, day) {
    var dd = new Date(date);
    dd.setDate(dd.getDate() + day);
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
    var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
    return y + "/" + m + "/" + d;
};
window.endTimeFn = function() {
    var date = getLocalTime(timeZoneParams);
    var dateYear = date.getFullYear();
    var dateMonth = date.getMonth() + 1;
    var dateDate = date.getDate();
    var date2 = getNextDate(dateYear+'/'+dateMonth+'/'+ dateDate,1);
    var blackLimitTime = new Date(date2).getTime() - date;
    return blackLimitTime;
}
//Flash Sale
$(function () {
    var flasDate = getLocalTime(timeZoneParams);
    var flashWeek = flasDate.getDay();
    if(flashWeek==0){
        flashWeek=7;
    }
    var flash_start_time = '2024/9/25 00:00:00';
    var flash_end_time = '2024/12/25 00:00:00' ;
    if(typeof flash_start_time != 'undefined'){
                      var date = getLocalTime(timeZoneParams);
                      var startFlashTime =new Date(flash_start_time);
                      var endFlashTime =new Date(flash_end_time);
                      var endAllFlashTime = endFlashTime.getTime() -date;
                      var allFlashTime = startFlashTime.getTime() - date;
                      function timerFlash(intDiff){
                          var day=0,
                              hour=0,
                              minute=0,
                              second=0;
                          intDiff = intDiff - 0;
                          if(intDiff > 0){
                              hour = Math.floor(intDiff /1000/60/60);
                              minute = Math.floor(intDiff /1000/60%60);
                              second =  Math.floor(intDiff/1000%60);
                          }
                          if(hour<10){
                              $('.home-flashClock_time--H .home-flashClock_time--num').text('0' + hour);
                          }else {
                              $('.home-flashClock_time--H .home-flashClock_time--num').text( hour);
                          }
                          if(minute<10){
                              $('.home-flashClock_time--M .home-flashClock_time--num').text('0' + minute);
                          }else {
                              $('.home-flashClock_time--M .home-flashClock_time--num').text(minute);
                          }
                          if(second<10){
                              $('.home-flashClock_time--S .home-flashClock_time--num').text('0' + second);
                          }else {
                              $('.home-flashClock_time--S .home-flashClock_time--num').text(second);
                          }
                      }
                      var startFlashFlag = true;
                      var endFlashFlag = true;
                      var endAllFlashTimeToday;
                      var limitFlashTime = setInterval(function(){
                          if(allFlashTime > 0){
                         
                              if(startFlashFlag){
                                  $('.home-flash_clock').hide();
                                  startFlashFlag = false;
                              }
                              allFlashTime = allFlashTime -1000;
                              // timerFlash(allFlashTime);
                          }else{
                              if(endFlashFlag){
                                  endAllFlashTime = endFlashTime.getTime() - date;
                                  endAllFlashTimeToday = endTimeFn();
                                  endFlashFlag = false;
                              }
                              if(endAllFlashTime > 0){
                                  $('.home-flash_clock').show();
                                  endAllFlashTime = endAllFlashTime - 1000;
                                  endAllFlashTimeToday = endAllFlashTimeToday - 1000;
                                  timerFlash(endAllFlashTimeToday);
                                  if(endAllFlashTimeToday < 0){
                                      endAllFlashTimeToday = endTimeFn();
                                  }
                              }else {
                                  clearInterval(limitFlashTime);
                              }
                          }
                      },1000);
            }
})